import { ClientConfig } from '@sanity/client';
import { LineOfBusiness } from '@spotify-internal/pillow-talk-too';
import { PropertyRef } from '@spotify-internal/remote-config-properties';

export enum Vertical {
  ARTISTS = 'artists',
  CONSUMER = 'consumer',
  PODCASTERS = 'podcasters',
}

export enum ColorScheme {
  LIGHT = 'light',
  DARK = 'dark',
}

export type RolloutConfig = {
  rolloutProperty: PropertyRef<boolean>;
  fallbackUrl: string;
};

export type VerticalConfig = {
  verticalName: Vertical;
  pathParam: string;
  cms: ClientConfig;
  features: FeatureConfig;
  locales: LocaleConfig;
  theme: `encore-${string}-theme`;
  colorScheme: ColorScheme;
  rolloutConfig: null | RolloutConfig;
};

export type VerticalConfigs = Record<Vertical, VerticalConfig>;

export type MastheadVariants = 's4a' | 'turnkey';

export type PillowTalkConfig = {
  lineOfBusiness: LineOfBusiness;
  redirectUri: string;
  showLoginDialog: boolean;
};

export type FeatureConfig = {
  showHeaderGradient: boolean;
  configureMasthead: {
    header: MastheadVariants;
    footer: MastheadVariants;
  } | null;
  communityLink: string | null;
  configurePillowTalk: PillowTalkConfig | null;
  emailMessagingFallback: boolean;
};

type LocaleConfig = {
  smartling: Record<string, string>;
  messagingLocales: Readonly<Array<string>>;
};
